export const getCorrectStrTime = (time: number | string) => (+time / 10 < 1 ? '0' + +time : time);
